'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Modal = require('react-bootstrap/lib/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _reactI18next = require('react-i18next');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var Prompt = (_dec = (0, _reactI18next.translate)(['common'], { withRef: true }), _dec(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(Prompt, _Component);

  function Prompt() {
    var _ref;

    (0, _classCallCheck3.default)(this, Prompt);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = Prompt.__proto__ || (0, _getPrototypeOf2.default)(Prompt)).call.apply(_ref, [this].concat(args)));

    _this.state = { show: false };
    return _this;
  }

  (0, _createClass3.default)(Prompt, [{
    key: 'show',
    value: function show(params) {
      this.setState((0, _extends3.default)({ show: true }, params));
    }
  }, {
    key: 'hide',
    value: function hide() {
      var onCancel = this.props.onCancel;

      this.setState({ show: false });
      if (onCancel) {
        onCancel(this.state.value);
      }
    }
  }, {
    key: 'submit',
    value: function submit(value) {
      var onOk = this.state.onOk;

      this.hide();
      onOk(value);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var t = this.props.t;
      var _state = this.state,
          title = _state.title,
          message = _state.message,
          okText = _state.okText,
          cancelText = _state.cancelText,
          show = _state.show,
          value = _state.value;


      return _react2.default.createElement(
        _Modal2.default,
        { show: show, onHide: this.hide },
        title && _react2.default.createElement(
          _Modal2.default.Header,
          null,
          _react2.default.createElement(
            _Modal2.default.Title,
            null,
            title
          )
        ),
        _react2.default.createElement(
          _Modal2.default.Body,
          null,
          message && _react2.default.createElement(
            'h4',
            null,
            message
          ),
          _react2.default.createElement('input', {
            type: 'text',
            className: 'width-perc-100',
            value: value,
            onChange: function onChange(e) {
              return _this2.setState({ value: e.target.value });
            },
            autoFocus: true,
            onFocus: function onFocus(e) {
              return e.target.value += '';
            },
            onKeyDown: function onKeyDown(e) {
              return e.which === 13 && _this2.submit(value);
            }
          })
        ),
        _react2.default.createElement(
          _Modal2.default.Footer,
          null,
          _react2.default.createElement(
            'button',
            { className: 'btn btn-accent', onClick: this.hide },
            cancelText || t('Cancel')
          ),
          _react2.default.createElement(
            'button',
            { className: 'btn btn-success', onClick: function onClick() {
                return _this2.submit(value);
              } },
            okText || t('Ok')
          )
        )
      );
    }
  }]);
  return Prompt;
}(_react.Component), _class3.propTypes = {
  onCancel: _propTypes2.default.func,
  t: _propTypes2.default.func
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'hide', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'hide'), _class2.prototype)), _class2)) || _class);
exports.default = Prompt;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Prompt/Prompt.js
// module id = 2069
// module chunks = 1